import * as net from 'util/Net';

import {LabAutomationTransform, TransformPreviewFile} from '../RunSchemaSpecConstants';

export interface GenerateTransformPreviewsResponse {
  previewFile: TransformPreviewFile;
}

export function generateTransformPreviews(
  spreadsheetUrl: string,
  spreadsheetFilename: string,
  automationFileConfigName: string,
  runSchemaId: string,
  transformSpecs: Array<LabAutomationTransform>
): Promise<GenerateTransformPreviewsResponse> {
  return net.postJSONPromise({
    url: '/1/api/automation-transforms/preview-files',
    data: {spreadsheetUrl, spreadsheetFilename, automationFileConfigName, runSchemaId, transformSpecs},
  });
}

export function generateBaseFilePreview(
  spreadsheetUrl: string,
  spreadsheetFilename: string,
  automationFileConfigName: string,
  runSchemaId: string
): Promise<{url: string}> {
  return net.postJSONPromise({
    url: '/1/api/automation-transforms/base-file',
    data: {spreadsheetUrl, spreadsheetFilename, automationFileConfigName, runSchemaId},
  });
}
